import { render, staticRenderFns } from "./review_list.vue?vue&type=template&id=6e045d8a&scoped=true"
import script from "./review_list.vue?vue&type=script&lang=js"
export * from "./review_list.vue?vue&type=script&lang=js"
import style0 from "./review_list.vue?vue&type=style&index=0&id=6e045d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e045d8a",
  null
  
)

export default component.exports